export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if(serializedState === null){
      return  {"auth":{"isAuthenticated":false}}
    }
    return {auth:JSON.parse(serializedState).auth}
  } catch (err) {
    return undefined
  }
}

export const saveState = (state) => {
  try{
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (err) {
    // Ignore write errors
  }
}



// WEBPACK FOOTER //
// ./src/redux/localStorage.js